import { useMutation, useQueryClient } from "@tanstack/react-query";

import { registerDevice } from "api/device.api";
import {
  invalidateDashboardSources,
  invalidateDeviceSide,
} from "lib/cacheInvalidation";

export const useCreateDevice = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body) => registerDevice(body),
    onSuccess: () => {
      invalidateDeviceSide(queryClient);
      invalidateDashboardSources(queryClient);
    },
  });
};
